import { render, staticRenderFns } from "./ProcessDetails.vue?vue&type=template&id=2383bd84&scoped=true"
import script from "./ProcessDetails.vue?vue&type=script&lang=js"
export * from "./ProcessDetails.vue?vue&type=script&lang=js"
import style0 from "./ProcessDetails.vue?vue&type=style&index=0&id=2383bd84&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383bd84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VContainer,VFlex,VLayout})
